import styled from 'styled-components';
import { ArrowRight } from 'styled-icons/feather';
import { lighten } from 'polished';
import Link from 'next/link';

import { colors } from '@/themes';
import Card from '@/components/card';
import SubTitle from '@/components/sub-title';
import Paragraph from '@/components/paragraph';
import Button from '@/components/button';

const Title = styled(SubTitle)`
  color: ${props => props.theme.colors.brand.primary};
  font-weight: 400;
  margin: 0 0 .25em;
`;

const Container = styled(Card)`
  cursor: pointer;
  display: flex;
  height: 100%;
  flex-direction: column;
  transition: transform 125ms;

  &:hover {
    transform: translateY(-.25em);

    ${Title} {
      color: ${props => lighten(.125, props.theme.colors.brand.primary)};
    }
  }
`;

const Meta = styled.small`
  display: block;
  color: ${props => props.theme.colors.typography.subtle};
`;

const PolicyExcerpt = ({ author, date, description, slug, title }) => {
  return (
    <Link href={`/policies/${slug}`} passHref>
      <Container>
        <Title maxSize="1.75em" minSize="1.5em" vw={6}>{title}</Title>
        <Meta>Posted by {author} on {date}</Meta>
        <Paragraph>{description}</Paragraph>
        <Button
          ghost
          to={`/policies/${slug}`}
          style={{
            alignSelf: 'flex-end',
            color: colors.brand.accent,
            marginTop: 'auto'
          }}>
          View Policy <ArrowRight strokeWidth={2} style={{ marginLeft: '.5em' }} />
        </Button>
      </Container>
    </Link>
  );
};

export default PolicyExcerpt;
